import React from 'react';
import { useIntl } from 'react-intl';
import {
    DISABLE_INTEGRATION_KAKAOTALK,
    DISABLE_INTEGRATION_NAVERTALK,
    DISABLE_INTEGRATION_FACEBOOK,
    DISABLE_INTEGRATION_INSTAGRAM,
    DISABLE_INTEGRATION_LINE,
    DISABLE_INTEGRATION_JANDI,
    DISABLE_INTEGRATION_SLACK,
} from '@/core/variables';
import { IntegrationChannels } from '@/model';
import { clickFromKeyboard } from '@/util/keyboardUtil';
import { useIntegration } from '@/query/integration';
import { useRouteHandler, useScenarioId } from '@/hook';
import ChannelThumb from '@/component/ChannlThumb';


const IntegrationView: React.FC = () => {
    const intl = useIntl();
    const scenarioId = useScenarioId();
    const { moveToIntegrationChannel } = useRouteHandler();

    const { data } = useIntegration(scenarioId);

    const getIntegrationEnable = (channel: string) => {
        if (channel === "web") {
            return true;
        }
        return data?.integrations?.[channel as keyof IntegrationChannels]?.enabled ?? false;
    };

    return (
        <main className="scenario-content-layout">
            <div className="w-md-page">
                <div className="pt-5 pb-7 px-6 flex flex-col gap-5 border border-black-200 rounded-[6px] bg-white">
                    <div className="ml-0.5 text-[16px] font-[600] text-black-500">
                        {intl.formatMessage({ id: "i08001" })}
                    </div>

                    <div className="grid grid-cols-[repeat(auto-fit,264px)] gap-x-3.5 gap-y-5">
                        {MESSENGER_CARD_LIST.filter((card) => card.isShow).map((card) => (
                            <div key={card.channel}
                                 role="button"
                                 tabIndex={0}
                                 aria-label={intl.formatMessage({ id: card.nameIntlKey })}
                                 className="p-4 flex flex-col gap-4 border border-black-200 rounded-[6px] cursor-pointer"
                                 onClick={() => moveToIntegrationChannel(scenarioId, card.channel === "web" ? "webchat" : card.channel)}
                                 onKeyDown={clickFromKeyboard}
                            >
                                <ChannelThumb channel={card.channel}
                                              className="size-6"
                                />
                                <div className="flex flex-col gap-2.5">
                                    <div className="flex items-center gap-2">
                                        <div className="text-[15px] font-[600] text-black-500">
                                            {intl.formatMessage({ id: card.nameIntlKey })}
                                        </div>
                                        {getIntegrationEnable(card.channel) && (
                                            <div role="status"
                                                 aria-label={intl.formatMessage({ id: "i08002" })}
                                                 className="badge-info"
                                            >
                                                {intl.formatMessage({ id: "i08002" })}
                                            </div>
                                        )}
                                    </div>
                                    <div className="text-[14px] text-black-500">
                                        {intl.formatMessage({ id: card.descriptionIntlKey })}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </main>
    );
};

interface MessengerCardProps {
    channel: string;
    nameIntlKey: string;
    descriptionIntlKey: string;
    isShow: boolean;
}

const MESSENGER_CARD_LIST: MessengerCardProps[] = [
    {
        channel: "web",
        nameIntlKey: "b0024",
        descriptionIntlKey: "i08003",
        isShow: true
    }, {
        channel: "kakaotalk",
        nameIntlKey: "b0043",
        descriptionIntlKey: "i08004",
        isShow: !DISABLE_INTEGRATION_KAKAOTALK
    }, {
        channel: "navertalk",
        nameIntlKey: "b0044",
        descriptionIntlKey: "i08005",
        isShow: !DISABLE_INTEGRATION_NAVERTALK
    }, {
        channel: "line",
        nameIntlKey: "b0045",
        descriptionIntlKey: "i08006",
        isShow: !DISABLE_INTEGRATION_LINE
    }, {
        channel: "facebook",
        nameIntlKey: "b0046",
        descriptionIntlKey: "i08007",
        isShow: !DISABLE_INTEGRATION_FACEBOOK
    }, {
        channel: "slack",
        nameIntlKey: "b0047",
        descriptionIntlKey: "i08008",
        isShow: !DISABLE_INTEGRATION_SLACK
    }, {
        channel: "jandi",
        nameIntlKey: "b0048",
        descriptionIntlKey: "i08009",
        isShow: !DISABLE_INTEGRATION_JANDI
    }, {
        channel: "instagram",
        nameIntlKey: "b0049",
        descriptionIntlKey: "i08010",
        isShow: !DISABLE_INTEGRATION_INSTAGRAM
    }
];

export default IntegrationView;
